import type { BoundaryEdge } from "../native/page-boundary";
import type { Camera } from "../native/geometry";
import type { Point } from "../scene/model";

/** Editor overlay only: fixed CSS-pixel width/contrast, beneath selection tools. */
export function drawPageBoundary(
  ctx: CanvasRenderingContext2D,
  edges: BoundaryEdge[],
  camera: Camera,
) {
  if (!edges.some((e) => e.intervals.length)) return;
  const screen = (p: Point) => ({
    x: Math.floor(p.x * camera.zoom + camera.x) + 0.5,
    y: Math.floor(p.y * camera.zoom + camera.y) + 0.5,
  });
  ctx.save();
  ctx.lineWidth = 1;
  ctx.lineCap = "butt";
  ctx.setLineDash([4, 4]);
  ctx.beginPath();
  for (const { start, end, intervals } of edges)
    for (const [from, to] of intervals) {
      const at = (t: number) =>
        screen({
          x: start.x + (end.x - start.x) * t,
          y: start.y + (end.y - start.y) * t,
        });
      const a = at(from),
        b = at(to);
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
    }
  for (const e of edges) {
    const p = screen(e.start);
    ctx.moveTo(p.x - 4, p.y);
    ctx.lineTo(p.x + 4, p.y);
    ctx.moveTo(p.x, p.y - 4);
    ctx.lineTo(p.x, p.y + 4);
  }
  ctx.strokeStyle = "#ffffff";
  ctx.lineDashOffset = 0;
  ctx.stroke();
  ctx.strokeStyle = "#334155";
  ctx.lineDashOffset = 4;
  ctx.stroke();
  ctx.restore();
}
